// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { PageInfoProps, PageInputProps } from '../../../interfaces'
import { GrupoUnidadMedidaProps } from '../../../interfaces/grupoUnidadMedida.ts'

const gqlQuery = gql`
  query GRUPOUNIDADMEDIDA($limit: Int!, $reverse: Boolean, $page: Int!, $query: String) {
    grupoUnidadMedidaListado(
      limit: $limit
      reverse: $reverse
      page: $page
      query: $query
    ) {
      pageInfo {
        totalDocs
      }
      docs {
        _id
        codigoGrupo
        nombreGrupo
        unidadMedidaBase {
          codigoUnidadMedida
          nombreUnidadMedida
          longitud
          ancho
        }
        definicion {
          unidadMedida {
            codigoUnidadMedida
            nombreUnidadMedida
          }
          cantidadBase
        }
        state
        usucre
        createdAt
        usumod
        updatedAt
      }
    }
  }
`

interface GrupoUnidadMedidaResponse {
  pageInfo: PageInfoProps
  docs: GrupoUnidadMedidaProps[]
}

export const apiGrupoUnidadMedida = async (
  pageInfo: PageInputProps,
): Promise<GrupoUnidadMedidaResponse> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)
  const data: any = await client.request(gqlQuery, { ...pageInfo })
  return data.grupoUnidadMedidaListado
}
